export default __webpack_public_path__ + "static/media/About_BG_Dark.1b773d98.jpg";